import '../styles/app.scss';
import './_images';
import lax from 'lax.js';
import { initLax } from "./components/lax-animation";
import './components/current-year';
import './components/roi-calculation';

// Global lax instance
window.lax = lax;

document.addEventListener(
	'DOMContentLoaded',
	() => {
		console.log('App ready');
	
		initLax();
	},
	false
);

